module.exports = __webpack_public_path__ + "attach.svg?7961f05b2816d61926acd5d6aac49eaf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vectors/attach.svg
// module id = 1077
// module chunks = 0